module.exports = __webpack_public_path__ + "img/oculus_hifi_5.fb8361fd.png";